export const RESET_BROWSE_USER = 'RESET_BROWSE_USER'
export const FETCH_USER_FROM_USERNAME_SUCCESS = 'FETCH_USER_FROM_USERNAME_SUCCESS'
export const FETCH_USER_FROM_USERNAME_FAIL = 'FETCH_USER_FROM_USERNAME_FAIL'
